import { Toaster as SonnerToaster } from 'sonner';
import {
  CheckCircle2,
  Info,
  AlertTriangle,
  AlertCircle,
  Loader2,
} from 'lucide-react';

export const Toaster = () => (
  <SonnerToaster
    position="bottom-right"
    icons={{
      success: <CheckCircle2 className="h-4 w-4 text-primary" />,
      info: <Info className="h-4 w-4 text-primary" />,
      warning: <AlertTriangle className="h-4 w-4 text-primary" />,
      error: <AlertCircle className="h-4 w-4 text-foreground" />,
      loading: <Loader2 className="h-4 w-4 text-muted-foreground animate-spin" />,
    }}
    toastOptions={{
      classNames: {
        toast:
          'bg-background border border-border text-foreground shadow-md rounded-lg font-sans',
        title: 'text-sm font-medium text-foreground',
        description: 'text-sm text-muted-foreground',
        actionButton:
          'bg-primary text-primary-foreground text-xs font-medium px-3 py-1.5 rounded-md hover:bg-primary/90',
        cancelButton:
          'bg-secondary text-secondary-foreground text-xs font-medium px-3 py-1.5 rounded-md hover:bg-secondary/80',
        closeButton:
          'border border-border bg-background text-muted-foreground hover:text-foreground hover:bg-muted',
      },
    }}
  />
);
